import { useState, useEffect, useCallback } from "react";
import ApiService from "../api/apiService";
import Websocket from "./ws";

const STORAGE_KEY = "buildhub_ai_tasks";

function loadTasks() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function useAITasks() {
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const _apiTasks = await ApiService.tasks.getMyTasks();
        if (_apiTasks && _apiTasks.success) {
          const apiTasks = _apiTasks.data.map((t) => {
            return {
              id: t.id,
              conversation: { ...t.conversation },
              message: { ...t.message },
              requester: {
                id: t.requester_id,
              },
              title: t.title,
              description: t.description,
              priority: t.priority,
              createdAt: t.createdAt,
              dueDate: t.dueDate,
            };
          });
          setTasks(apiTasks);
        }
      } catch {}
    };

    fetchTasks();
    const interval = setInterval(fetchTasks, 5 * 60 * 1000);

    // The server emits tasks_updated as soon as the AI creates tasks.
    // The socket may not exist yet on mount, so attach once it does.
    const ws = new Websocket();
    let attachedSocket = null;
    const attach = () => {
      if (attachedSocket || !ws.socket) return;
      attachedSocket = ws.socket;
      attachedSocket.on("tasks_updated", fetchTasks);
    };
    attach();
    const attachTimer = setInterval(() => {
      attach();
      if (attachedSocket) clearInterval(attachTimer);
    }, 2000);

    return () => {
      clearInterval(interval);
      clearInterval(attachTimer);
      if (attachedSocket) attachedSocket.off("tasks_updated", fetchTasks);
    };
  }, []);

  const toggleTask = useCallback((id) => {
    setTasks((prev) =>
      prev.map((t) => (t.id === id ? { ...t, isDone: !t.isDone } : t)),
    );
  }, []);

  const pendingCount = tasks.length;

  return { tasks, toggleTask, pendingCount };
}
